import ExpertiseTab from './ExpertiseTab';
export default ExpertiseTab;